import script from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=d67cd44e&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d67cd44e"]])

export default __exports__